<span *ngIf="yearsOptions">
  <b>
    Select Reporting Year:
  </b> <app-dropdown
  [inputFormControl]="yearsFormControl"
  [options]="yearsOptions"
  ></app-dropdown>
</span>
